import dayjs from 'dayjs';

export const DATE_RANGE_PRESETS = [
  { id: 'today', labelKey: 'reservationSources.today', unit: 'day' },
  { id: 'thisWeek', labelKey: 'reservationSources.thisWeek', unit: 'isoWeek' },
  { id: 'thisMonth', labelKey: 'reservationSources.thisMonth', unit: 'month' },
];

export const DEFAULT_DATE_RANGE_PRESET = 'thisWeek';

// dayjs's 'Z' format token yields a colon-separated UTC offset
// (e.g. +02:00), matching what /kori/stats/source expects.
const KORI_DATE_FORMAT = 'YYYY-MM-DDTHH:mm:ssZ';

export const getPresetRange = (presetId) => {
  const now = dayjs();
  const preset = DATE_RANGE_PRESETS.find(p => p.id === presetId) ?? DATE_RANGE_PRESETS[0];
  return {
    alku: now.startOf(preset.unit).format(KORI_DATE_FORMAT),
    loppu: now.format(KORI_DATE_FORMAT),
  };
};
